import { useMemo } from 'react'
import styled from '@emotion/styled'
import { useScreen } from '../../utils/responsive-helper'
import { HepatitisHistoryCard } from './component'
import Headbar from '../../components/common/HeadBar'
import * as paths from '../../constant/path'
import Tabs from '../../components/common/Tabs'
import colors from '../../constant/colors'
import { UserClaimList, EClaimHistory as EClaimHistoryType, EClaimStatus } from '../../services/e-claim/e-claim-types'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useGetHepatitisHistoryList } from '../../services/hepatitis/hepatitis-query'

const Layout = styled.div`
  margin-bottom: 40px;
`
const ContentLayout = styled.div`
  background-color: ${colors.WHITE};
  padding: 16px;
  border-radius: 16px;
  min-height: 500px;
`
const HepatitisCardLayout = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`

type HepatitisHistoryPageProps = {
  data: EClaimHistoryType
}
const HepatitisHistoryPage = (props: Partial<HepatitisHistoryPageProps>) => {
  const { data } = props

  return (
    <HepatitisCardLayout>
      {data?.userClaimList?.map((item: UserClaimList) => (
        <Link
          key={item.claimId}
          to={paths.hepatitisHistoryDetail({ routeParam: { id: item.id } })}
        >
          <HepatitisHistoryCard data={item} status={data?.statusName} />
        </Link>
      ))}
    </HepatitisCardLayout>
  )
}

const HepatitisHistory = () => {
  const { isMobile } = useScreen()
  const { t } = useTranslation()
  const { data: HepatitisHistoryList } = useGetHepatitisHistoryList()

  const dataSource = useMemo(() => {
    return [
      {
        name: t('eClaim.history.status.pending'),
        key: '0',
        page: <HepatitisHistoryPage data={HepatitisHistoryList?.filter((item: EClaimHistoryType) => item.statusName === EClaimStatus.UNAPPROVED)[0]} />,
      },
      {
        name: t('eClaim.history.status.cancel'),
        key: '1',
        page: <HepatitisHistoryPage data={HepatitisHistoryList?.filter((item: EClaimHistoryType) => item.statusName === EClaimStatus.CANCELED)[0]} />,
      },
      {
        name: t('eClaim.history.status.rejected'),
        key: '2',
        page: <HepatitisHistoryPage data={HepatitisHistoryList?.filter((item: EClaimHistoryType) => item.statusName === EClaimStatus.REJECTED)[0]} />,
      },
      {
        name: t('eClaim.history.status.approved'),
        key: '3',
        page: <HepatitisHistoryPage data={HepatitisHistoryList?.filter((item: EClaimHistoryType) => item.statusName === EClaimStatus.APPROVED)[0]} />,
      },
    ]
  }, [HepatitisHistoryList])

  return (
    <>
      <Layout style={{ paddingTop: '24px' }}>
        <Headbar title={t('eClaim.history.title')} backWard={paths.hepatitis()} titleColor={colors.BLACK} />
        <ContentLayout>
          <Tabs
            dataSource={dataSource}
            mode={isMobile ? 'select' : undefined}
          />
        </ContentLayout>
      </Layout>
    </>
  )
}
export default HepatitisHistory 